import PropTypes from 'prop-types';
import React from 'react';

import Station from '../../records/Station';
import HighlightedText from '../general/HighlightedText';

import FeatureFlagStore from '../../stores/FeatureFlagStore';
import connectToStores from '../../helpers/connectToStores';

function _getStateFromStores () {
    return {
        enableAdditionalStationInfo: FeatureFlagStore.get('enableAdditionalStationInfo')
    };
}
function StationListItem ({ data, search, enableAdditionalStationInfo }) {
    const note = data.displayInfo && data.displayInfo.get('stationNameDisplayNote');
    return (
        <div className="station-selector__item station-name">
            <HighlightedText
                text={`${data.name}${note && enableAdditionalStationInfo ? ` ${note}` : ''}`}
                textToHighlight={ search }
                highlightClass="station-selector__item--highlight"
            />

            <span className="station-selector__item-code pull-right">
                { data.crs.toUpperCase() }
            </span>
        </div>
    );
}


StationListItem.propTypes = {
    data: PropTypes.instanceOf(Station).isRequired,
    search: PropTypes.string,
    enableAdditionalStationInfo: PropTypes.bool
};

StationListItem.defaultProps = {
    search: null,
    enableAdditionalStationInfo: false
};

export default connectToStores([ FeatureFlagStore ], _getStateFromStores)(StationListItem);
